import { render } from "./VcxToAed.vue?vue&type=template&id=35757845&scoped=true"
import script from "./VcxToAed.vue?vue&type=script&lang=js"
export * from "./VcxToAed.vue?vue&type=script&lang=js"

import "./VcxToAed.vue?vue&type=style&index=0&id=35757845&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35757845"]])

export default __exports__